import axiosConfig from "./axiosConfig";

export interface DocumentIdRecord {
  type: string;
  number: number;
  createdAt: string;
  siteID: string | null;
  key: string;
  note: string;
  manuallyCreated: boolean;
  isVoided: boolean;
}

export interface DocumentIdsResponse {
  documentIds: DocumentIdRecord[];
}

const getDocumentIds = async (
  authToken: string,
  type: string,
  startDate: string,
  endDate: string
): Promise<DocumentIdsResponse> => {
  const params = new URLSearchParams({ type, startDate, endDate });
  const { data } = await axiosConfig.get(`/document-ids?${params.toString()}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return data;
};

export default getDocumentIds;
